import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'if0014',
    ecrans: ['00-2'],
    params: [
        'id',
        '?itdcleintgen',
        '?itscleint'
    ]
});
